// extracted by mini-css-extract-plugin
module.exports = {"businessModalImage":"BusinessModal_businessModalImage__29t85"};